export default __webpack_public_path__ + "img/bg_dashboard_card.a9a8dd23.svg";